import { FilterOutlined } from "@ant-design/icons";
import { Badge } from "antd";
import { FC } from "react";

import { StyledButton } from "./Styled";

interface HeaderFilterButtonProps {
    filterCount: number;
    onClick: () => void;
    active?: boolean;
}

export const HeaderFilterButton: FC<HeaderFilterButtonProps> = ({
    filterCount,
    onClick,
    active = false,
}) => {
    return (
        <Badge count={filterCount}>
            <StyledButton
                type="text"
                onClick={onClick}
                icon={<FilterOutlined style={{ fontSize: 22 }} />}
                $active={active}
            />
        </Badge>
    );
};
